// Initialize LivePerson chat variables
var lpTag = lpTag || {}; lpTag.vars = lpTag.vars || []; lpTag.dbs = lpTag.dbs || [];
lpTag.section = 'default';
var arrLPvars = [
        // 'unit' is required in most deployments, other values: service for the unauthenticated site
        { scope: 'page', name: 'unit', value: 'service-auth' },
        // 'language' is required in deployments that do, or may in the future, need multi-lingual support
        { scope: 'session', name: 'language', value: 'english' }
];
lpTag.vars.push(arrLPvars);

$(document).ready(function () {
    // Configure the chat button
    var containerName = "#livePersonChatButton"; // Container for the button in the theme
    var buttonName = "";

    var windowLoc = window.location.href.toLowerCase();

    // The name of the button is dependent on the environment.
    if (windowLoc.indexOf("onlinebanking.ecu.com") > -1) {
        buttonName = "lpchatsso";
    } else if (windowLoc.indexOf("educatorsstaging.orb") > -1) {
        buttonName = "lpchatsso-staging";
    } else if (windowLoc.indexOf("educators.qa") > -1) {
        buttonName = "lpchatsso-qa";
    } else if (windowLoc.indexOf("educators.dev") > -1) {
        buttonName = "lpchatsso-dev";
    } else if (windowLoc.indexOf("developer.dev") > -1) {
        buttonName = "lpchatsso-dynamic";
    }

    if (buttonName !== "") {
        $(containerName).empty().append('<div id="' + buttonName + '"></div>');

        // Now, load the LivePerson chat script
        $.getScript("/Orbital/Educators/Scripts/le-mtagconfig.desktop.min.js");
    }
});

(function () {
    var silvercloudSearchInput = document.querySelector('#silvercloud_search_input');
    var silvercloudSearchButton = document.querySelector('#silvercloud_search_button');
    var silvercloudSearchSubmit = function (e) {
        if (e.type === 'click' || e.type === 'keypress' && e.keyCode === 13) {
            window.location.href = "https://www.ecu.com/silvercloud-search-results/?q=" + silvercloudSearchInput.value;
        }
    };

    silvercloudSearchInput.addEventListener('keypress', silvercloudSearchSubmit);
    silvercloudSearchButton.addEventListener('click', silvercloudSearchSubmit);
})();
